// extracted by mini-css-extract-plugin
module.exports = {"inputRoot":"DateRangeController_inputRoot__1hYLj","arrowIcon":"DateRangeController_arrowIcon__t2PjP"};